import React, { useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "react-bootstrap";
import { FtextField } from "../../../components/common/FtextField";
import { useTranslation } from "react-i18next";
import Loader from "../../../components/common/Loader";
import { useDispatch, useSelector } from "react-redux";
import { postIspOwnerSupporterNumber } from "../../../features/apiCalls";

const SupportNumberPost = ({ show, setShow }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //get isp owner id
  const ispOwner = useSelector(
    (state) => state.persistedReducer.auth?.ispOwnerId,
  );

  //Loading state
  const [isLoading, setIsLoading] = useState(false);

  // supports validation
  const customerValidator = Yup.object({
    name: Yup.string().min(3).required(t("writeSupportName")),
    mobile: Yup.string().required(t("writeMobileNumber")),
    start: Yup.date().required(t("selectStartTime")),
    end: Yup.date().required(t("selectEndTime")),
  });

  // modal close handler
  const handleClose = () => setShow(false);

  // support number submit handler
  const supportNumbersHandler = (formValues) => {
    const sendingData = {
      ...formValues,
      ispOwner: ispOwner,
    };

    postIspOwnerSupporterNumber(dispatch, sendingData, setIsLoading, setShow);
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <ModalHeader closeButton>
        <ModalTitle>{t("createCustomersSupporter")}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Formik
          initialValues={{
            name: "",
            mobile: "",
            start: new Date(),
            end: new Date(),
          }}
          validationSchema={customerValidator}
          onSubmit={(values) => {
            supportNumbersHandler(values);
          }}
          enableReinitialize
        >
          {() => (
            <Form id="support">
              <div className="displayGrid">
                <FtextField
                  type="text"
                  label={t("name")}
                  name="name"
                  validation={"true"}
                />

                <FtextField
                  type="text"
                  label={t("mobile")}
                  name="mobile"
                  validation={"true"}
                />

                <FtextField
                  {...{
                    name: "start",
                    type: "date",
                    id: "start",
                    validation: true,
                    label: t("selectStartTime"),
                    placeholderText: "HH:mm A",
                    component: "DatePicker",
                    dateFormat: "hh:mm a",
                    timeIntervals: 1,
                    showTimeSelect: true,
                    showTimeSelectOnly: true,
                  }}
                />

                <FtextField
                  {...{
                    name: "end",
                    type: "date",
                    id: "end",
                    validation: true,
                    label: t("selectEndTime"),
                    placeholderText: "HH:mm A",
                    component: "DatePicker",
                    dateFormat: "hh:mm a",
                    timeIntervals: 1,
                    showTimeSelect: true,
                    showTimeSelectOnly: true,
                  }}
                />
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={isLoading}
          type="submit"
          className="btn btn-success"
          form="support"
        >
          {isLoading ? <Loader /> : "submit"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SupportNumberPost;
